module.exports = __webpack_public_path__ + "static/img/建筑智能化_建筑智能化3@2x.4351141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/建筑智能化_建筑智能化3@2x.png
// module id = kd6f
// module chunks = 1